import styled from 'styled-components'

export const Container = styled.div`
  flex: 1;

  width: 100%;
  display: flex;
  flex-direction: column;
`

export const SubTitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`

export const LabelCompany = styled.label`
  overflow: hidden;
  color: var(--foreground-neutral-faded, #4d5874);

  flex: 1;
  text-overflow: ellipsis;
  white-space: nowrap;

  font-size: 12px;
  font-style: normal;
  font-weight: 400;
`

export const RowContainer = styled.div`
  display: flex;
  flex-direction: row;

  width: 100%;

  border-top: 1px solid var(--Border-Neutral-faded, #dfe2ea);

  :first-child {
    border-top: none;
  }
`

export const SectionActions = styled.div`
  flex: 1;
  padding: 16px;

  box-sizing: border-box;
  display: flex;
  align-self: start;
  justify-content: end;

  div {
    padding: 8px;
  }
`

export const FormContainer = styled.div`
  flex: 1;
  padding: 16px;
  box-sizing: border-box;

  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const SectionTitle = styled.div`
  color: var(--Foreground-Neutral, #14171f);

  /* Body 3/Medium */
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
`

export const ValueContainer = styled.div`
  display: flex;
  flex-direction: row;
  /* align-items: center; */
  gap: 6px;
`

export const ValueLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;

  color: var(--Foreground-Neutral-faded, #4d5874);

  /* Body 3/Regular */
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
`

export const IconImg = styled.div`
  display: flex;
  align-items: center;

  opacity: 0.6;

  width: 16px;
  height: 16px;

  margin-top: 2px;

  svg {
    width: 16px;
    height: 16px;
  }
`

export const DatePickerInput = styled.div`
  position: relative;
`

export const DatePickerContainer = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
`

export const AddCommentContainer = styled.div`
  width: 100%;
  & > div {
    padding: 16px;
  }
`
